module.exports = __webpack_public_path__ + "html/light-landing_00139a0deae1d2b1f8ced18569d5ca74.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing/light/light-landing.html
// module id = FnqE
// module chunks = 151